import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  ApiResponse,
  ApiClientService
} from './../../shared/services/api-client.service';
import { AB_API_LOGIN } from './../../shared/constants';

enum tokentype {
  mobilephoneValue = 'softToken',
  abopassValue = 'hardToken'
}
interface LoginRequest extends ApiResponse {
  username: string;
  logincode: string;
  otpType: tokentype;
}

interface LoginResponse extends LoginRequest {
  DisableMode: string;
  callIsSuccess: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class LoginService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_LOGIN);
  }

  login(loginInputRequest: LoginRequest): Observable<LoginResponse> {
    return this.postWithButtonLoader({
      username: loginInputRequest.username,
      password: loginInputRequest.logincode,
      tokentype: tokentype[loginInputRequest.otpType]
    });
  }

  logout(): Observable<ApiResponse> {
    return this.delete();
  }
}

export { LoginRequest, LoginResponse };
